import React from "react";
import styled from "styled-components";

export default styled.img`
    width: 66px;
    height: 66px;
    display: inline-block;
    top: 8px;
    position: relative;
    right: 15px;
`;